import { useEffect, useState } from 'preact/hooks'
import { chunkFailed } from './reload/pageReload'

/**
 * Load a lazy chunk once `on` is true; the module, or null until it has arrived. `cache` keeps
 * the module across mounts so a second mount renders at once. A chunk that will not load (a stale
 * deploy, D-066) goes to `chunkFailed`: the page reloads once, else the Reload banner shows.
 */
export function useChunk<M>(on: boolean, load: () => Promise<M>, cache: { m: M | null }): M | null {
  const [mod, setMod] = useState<M | null>(cache.m)
  useEffect(() => {
    if (!on || mod) return
    let live = true
    load().then(
      (m) => {
        cache.m = m
        if (live) setMod(() => m)
      },
      (err: unknown) => chunkFailed(err),
    )
    return () => {
      live = false
    }
  }, [on, mod, load, cache])
  return mod
}
